export default __webpack_public_path__ + "static/20250929-23ad2fa19fa2f270687bd51ac26e01e2.png";